import { env } from './env'

export const VISIO_CONFIG_RELAY = 'relay'
export const MED_GE = 'Médecine Générale'
export const RTC_GOOD = 'Good'
export const RTC_AVERAGE = 'Average'
export const RTC_BAD = 'Bad'
export const MAX_VIDEO_CONNECTION_ATTEMPT = 5

export const ELIGIBLE = 'Eligible'
export const ELIGIBLE_SOUS_RESERVE = 'Eligible sous réserve'
export const NON_ELIGIBLE = 'Non éligible'
export const FAIL_NON_BLOCKING = 'failNonBlocking'
export const FAIL_BLOCKING = 'failBlocking'
export const PASS = 'pass'
export const STEP_WEBCAM = 'webcam'
export const STEP_MICRO = 'microphone'
export const STEP_SPEAKER = 'speaker'
export const STEP_WEBRTC = 'webrtc'
export const STEP_REPORT = 'report'
export const STEP_INTRO = 'intro'
export const OUI = 'Oui'
export const NON = 'Non'
export const PUSHCONFORMITYLATER = 'pushConformityLater'
export const DEFAULT_MT = 'non renseigné'
export const GOOD = 'Bon'
export const CORRECT = 'Correcte'
export const BAD = 'Mauvais'
export const UNKNOWN = 'Inconnu'

export const SNACKBAR_DISPLAY = 'SNACKBAR_DISPLAY'
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE'

export const MEDICAL_ACT_HISTORY = 'MEDICAL_ACT_HISTORY'

export const SUMMARY_MODEL = 'SummaryModel'

export const SAVED_STATUS = 'SAVED'
export const UNSAVED_STATUS = 'UNSAVED'
export const SAVING_STATUS = 'SAVING'

export const HELP_CENTER_URL = env('REACT_APP_HELP_CENTER_REQUIRED_EXPERT') ?? ''

export const TRANSMISSION_ALERT_TOOLTIP_CONTENT =
    'Nombre de téléexpertise prise en charge par l’Assurance Maladie restante à date, conformément à la limitation légale fixée par l’Assurance Maladie, à 4 actes facturables par an pour un même duo patient-requis.'
export const MAX_TLE_NUMBER_PER_YEAR = 4

// Act base info barely changes while the act is open: keep it cached for 5 minutes
export const ACT_INFO_CACHE_DURATION = 5 * 60 * 1000

export const MISSING_AM_NUM = 'Le n°AM doit être fourni'
export const WRONG_AM_NUM_LENGTH =
    'Le n° AM doit contenir soit 9, 15, 16 ou 17 chiffres. Vous pouvez le trouver sur vos feuilles de soins.'
export const AM_NUM_DEFINITION =
    'Il s’agit de l’identifiant composé de 9, 15, 16 ou 17 chiffres, indiqué sur vos feuilles de soins, dans la rubrique “identification de la structure” entourée ci-contre.'

export const PPC_UNSUPPORTED_BROWSER_MESSAGE =
    "Votre navigateur n'est pas compatible avec les actes de PPC. Veuillez utiliser Google Chrome, Microsoft Edge ou Mozilla Firefox"
export const EPRESCRIPTION_UNSUPPORTED_BROWSER_MESSAGE =
    "Votre navigateur n'est pas compatible avec le module de e-prescription. Veuillez utiliser Google Chrome, Microsoft Edge ou Mozilla Firefox."
